// removed by extract-text-webpack-plugin
module.exports = {"root":"Card__root__3DP_V","imgContainer":"Card__imgContainer__z5jV6","titleWrapper":"Card__titleWrapper__9zJWu","title":"Card__title__o7-3H","subtitle":"Card__subtitle__3Mv0j","text":"Card__text__3MWzh","link":"Card__link__1rKKh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/Card.css
// module id = 1623
// module chunks = 0